import { booleanAttribute, Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { CONVERSATION_ROUTES_TOKEN } from '../../../../core/src/lib/tokens';

@Component({
  selector: 'inbox-zero',
  imports: [TranslateModule, MatButtonModule, GalaxyEmptyStateModule, RouterLink],
  templateUrl: './inbox-zero.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./inbox-zero.component.scss'],
})
export class InboxZeroComponent {
  @Input({ transform: booleanAttribute }) showNewMessageButton = false;

  private readonly routes = toSignal(inject(CONVERSATION_ROUTES_TOKEN));

  newMessageUrl = this.routes()?.sendNewMessage;
}
